import { render, staticRenderFns } from "./StatusCampanhas.vue?vue&type=template&id=741e3e5b"
import script from "./StatusCampanhas.vue?vue&type=script&lang=js"
export * from "./StatusCampanhas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports